import{createElement as t}from"../../../external/preact/dist/preact.js";const e=({buttonStyle:e,buttonType:a,buttonLocale:o,onClick:l})=>t("apple-pay-button",{"data-testid":"apple-pay-button",buttonstyle:e,type:a,locale:o,onclick:l});export{e as default};
//# sourceMappingURL=ApplePayButton.js.map
